import React, { PropsWithChildren, useMemo } from 'react';

import './TableFilters.scss';

type TableFiltersProps = {
    className?: string;
    columns: any[];
    onFilter: (id: string, type: string, dataIndex: string, value: any) => void;
    filters: Record<string, any>;
} & PropsWithChildren;

export const TableFilters = ({ children, className, columns, onFilter, filters }: TableFiltersProps) => {
    const tableHasFilters = useMemo(() => {
        return columns.some(col => col.filterInfo);
    }, [columns]);

    return (
        <thead className={className}>
            {children}
            {tableHasFilters ? (
                <tr className='resizable-table-filters'>
                    {columns?.map((col, index) => {
                        const { Filter, id, dataIndex, type, placeholder } = col?.filterInfo ?? {};

                        if (!col?.filterInfo) return <th className='table-filter-container' key={`${index}-filter`} />;

                        if (!Filter || !id || !dataIndex || !type) return <th className='table-filter-container' key={`${index}-filter`} />;

                        return (
                            <th className='table-filter-container' key={`${dataIndex}-filter`}>
                                {Filter ? (
                                    <Filter
                                        onChange={(value) => {
                                            onFilter(id, type, dataIndex, value);
                                        }}
                                        value={filters[id]?.value}
                                        placeholder={placeholder}
                                    />
                                ) : null}
                            </th>
                        );
                    }
                    )}
                </tr>
            ) : null}
        </thead>
    );
};
